// src/components/FAQ/faqData.js

export const faqCategories = [
    { id: 'all', label: 'All Questions' },
    { id: 'pricing', label: 'Pricing' },
    { id: 'tech', label: 'Technical' },
    { id: 'process', label: 'Process' },
    { id: 'support', label: 'Support' }
];

export const faqData = [
    {
        id: 1,
        category: 'pricing',
        question: "How much does a website cost?",
        answer: "Website cost depends on features, pages, and complexity. Basic sites start from $500, e-commerce from $2000, and custom web apps from $5000. We provide detailed quotes after understanding your requirements."
    },
    {
        id: 2,
        category: 'pricing',
        question: "What are your payment terms?",
        answer: "We work with 50% upfront and 50% on delivery. For large projects, we offer milestone-based payments: 30% start, 40% mid-project, 30% final delivery."
    },
    {
        id: 3,
        category: 'tech',
        question: "React or Next.js — which is better for my project?",
        answer: "React is great for interactive UIs, Next.js adds SEO and performance benefits. For marketing sites, Next.js is better. For dashboards, React works perfectly. We recommend based on your goals."
    },
    {
        id: 4,
        category: 'tech',
        question: "Do you build mobile apps too?",
        answer: "Yes! We build native iOS/Android apps and cross-platform apps using React Native or Flutter. We also create Progressive Web Apps (PWA) for budget-friendly mobile solutions."
    },
    {
        id: 5,
        category: 'process',
        question: "How long does a typical project take?",
        answer: "Timeline depends on scope: Landing page (2-3 weeks), Corporate website (4-6 weeks), E-commerce (8-12 weeks), Custom web app (3-6 months). We provide exact timelines after discovery."
    },
    {
        id: 6,
        category: 'process',
        question: "What is your development process?",
        answer: "Our 5-step process: 1) Discovery & Consultation, 2) Design & Planning, 3) Development, 4) Testing & QA, 5) Deployment & Support. You're involved at every stage."
    },
    {
        id: 7,
        category: 'support',
        question: "Do you provide maintenance after launch?",
        answer: "Absolutely! We offer 3 months free support post-launch. After that, choose from our maintenance plans: Basic ($200/month), Standard ($500/month), or Enterprise (custom)."
    },
    {
        id: 8,
        category: 'support',
        question: "Who owns the source code?",
        answer: "You own 100% of the source code after final payment. We provide complete documentation, repository access, and deployment files. No lock-in, ever."
    },
    {
        id: 9,
        category: 'tech',
        question: "Is my data secure with you?",
        answer: "Security is our priority. We use SSL encryption, secure APIs, regular backups, and follow OWASP guidelines. For sensitive projects, we sign NDAs and use VPN-protected environments."
    },
    {
        id: 10,
        category: 'pricing',
        question: "Do you offer ERP system customization?",
        answer: "Yes, we customize Odoo, SAP, and custom ERP solutions. Pricing starts from $10,000 depending on modules: inventory, finance, HR, manufacturing, etc. We provide free consultation."
    }
];